(function () {
  if (window.innerWidth > 767) return;

  function init() {
    var bar = document.getElementById('mem-sticky-mobile-cta');
    if (!bar) return;
    var cta = bar.querySelector('button.cta');
    var memContainer = document.getElementById('preview-root-app-container');

    var isModalMode = !!(memContainer && memContainer.querySelector('.mem-personalized-dummy-btn'));

    setTimeout(function () {
      document.body.classList.add('mem-sticky-active');
      bar.classList.add('visible');
      bar.setAttribute('aria-hidden', 'false');
    }, 300);

    if (!isModalMode && 'IntersectionObserver' in window && memContainer) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== memContainer) return;
            if (entry.intersectionRatio > 0.5) {
              bar.classList.remove('visible');
            } else {
              bar.classList.add('visible');
            }
          });
        },
        { threshold: [0, 0.5] }
      );
      observer.observe(memContainer);
    }

    if (cta) {
      cta.addEventListener('click', function () {
        var target = document.getElementById('preview-root-app-container');
        if (!target) return;

        var mainCta = target.querySelector('.mem-personalized-dummy-btn') ||
                      target.querySelector('button.mem-cta, button[class*="personalize"]');
        if (mainCta) {
          mainCta.scrollIntoView({ behavior: 'smooth', block: 'center' });
          mainCta.classList.add('mem-cta-pulse');
          setTimeout(function () { mainCta.classList.remove('mem-cta-pulse'); }, 2000);
          return;
        }

        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(function () {
          var inp = target.querySelector('input[type="text"], input');
          if (inp && typeof inp.focus === 'function') inp.focus();
        }, 600);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* MEM personalization: required-field validation + select styling
   (Claude, 25 Jul 2026, v2: every line required; a single space = intentional blank)
   v3 (26 Jul 2026): also speak up when MEM has DISABLED the Add-to-Cart button.
   Previously we bailed out on `.disabled`, so an empty form produced a dead,
   silent button with no explanation. Now a click on the disabled button shows
   the same red guidance as the monogram page. If nothing is actually missing
   the button may be disabled for a legitimate reason (widget still loading) —
   in that case we stay silent, exactly as before. */
(function(){
  if(typeof window.monogramSelectedVariant==='undefined'){window.monogramSelectedVariant=function(){return undefined;};}
  var s=document.createElement('style');
  s.textContent='#preview-root-app-container .design-element-input-wrapper select{background-color:#EBEBEB;border:0.8px solid #888;border-radius:4px;padding:10px 12px;width:100%;font-size:14px;color:#121212;cursor:pointer;-webkit-appearance:menulist;appearance:menulist;box-sizing:border-box}#preview-root-app-container .mem-field-missing input,#preview-root-app-container .mem-field-missing select{border:2px solid #D02E2E !important;background-color:#FDECEC !important}#preview-root-app-container .mem-field-missing label{color:#D02E2E !important}#mem-required-error{display:none;color:#D02E2E;font-size:14px;font-weight:600;margin:8px 0;line-height:1.4}#mem-required-error.visible{display:block}#preview-root-app-container .embed-ui-atc-wrapper.disabled{cursor:pointer}';
  document.head.appendChild(s);

  function root(){return document.getElementById('preview-root-app-container');}

  function collect(r){
    var ws=r.querySelectorAll('.design-element-input-wrapper');
    var selMiss=[],txtMiss=[];
    Array.prototype.forEach.call(ws,function(w){
      var f=w.querySelector('select, input:not([type=hidden]), textarea');
      if(!f)return;
      if(f.tagName==='SELECT'){ if(!f.value){selMiss.push(w);} }
      else { if(f.value===''){txtMiss.push(w);} }
    });
    return {miss:selMiss.concat(txtMiss), selMiss:selMiss.length, txtMiss:txtMiss.length};
  }

  function clearState(r){
    Array.prototype.forEach.call(r.querySelectorAll('.mem-field-missing'),function(w){w.classList.remove('mem-field-missing');});
    var m=document.getElementById('mem-required-error');
    if(m){m.classList.remove('visible');}
  }

  function showErr(r,atc,res){
    var m=document.getElementById('mem-required-error');
    if(!m){
      m=document.createElement('div');
      m.id='mem-required-error';
      m.setAttribute('role','alert');
      var c=atc.closest('.embed-ui-qty-atc-container')||atc;
      c.parentElement.insertBefore(m,c);
    }
    var p=[];
    if(res.selMiss){p.push('Please select your initial.');}
    if(res.txtMiss){p.push('Please fill in every personalization line. Want a line left blank on your sign? Just type a single space in it.');}
    m.textContent=p.join(' ');
    m.classList.add('visible');
    Array.prototype.forEach.call(res.miss,function(w){w.classList.add('mem-field-missing');});
    var first=res.miss[0];
    if(first){
      first.scrollIntoView({behavior:'smooth',block:'center'});
      var f=first.querySelector('select, input, textarea');
      if(f&&f.focus){try{f.focus({preventScroll:true});}catch(e){f.focus();}}
    }
  }

  document.addEventListener('click',function(e){
    if(!e.target||!e.target.closest){return;}
    var atc=e.target.closest('.embed-ui-atc-wrapper');
    if(!atc){return;}
    var r=root();
    if(!r||!r.contains(atc)){return;}
    clearState(r);
    var res=collect(r);
    if(!res.miss.length){return;}
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    showErr(r,atc,res);
  },true);

  function reval(e){
    var m=document.getElementById('mem-required-error');
    if(!m||!m.classList.contains('visible')){return;}
    if(!e.target||!e.target.closest){return;}
    var r=root();
    if(!r||!r.contains(e.target)){return;}
    clearState(r);
    var res=collect(r);
    if(res.miss.length){
      Array.prototype.forEach.call(res.miss,function(w){w.classList.add('mem-field-missing');});
      m.classList.add('visible');
    }
  }
  document.addEventListener('input',reval,true);
  document.addEventListener('change',reval,true);
})();
;typeof window.RENDERING_DOWNLOAD_PNG_BUTTON=="undefined"&&(window.RENDERING_DOWNLOAD_PNG_BUTTON=function(){return!1});